import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { IconAccount } from '@americanexpress/dls-icons';
import { useGetMRPointsBalance, useGetTopCardDescription, useTopCard } from '../../apiHooks/membershipHooks';
import dlsStyles from '../../styles/dls.css';
import profileStyles from './ProfielDrawerTitleSection.scss';
import { useIsLoggedIn, useNavigationLinksHook } from '../../apiHooks/apiHooks';
import styles from '../TravelHeader.scss';
import Benefits from '../Benefits/Benefits';

const ProfileDrawerTitleSection = () => {
  const topCard = useTopCard();
  const { formatMessage } = useIntl();
  const { data: isLoggedIn } = useIsLoggedIn();
  const MRPoints = useGetMRPointsBalance();
  const { data: navLinks } = useNavigationLinksHook();
  const topCardName = useGetTopCardDescription();
  const firstName = topCard?.demographics?.firstName;
  const hasMembershipError = isLoggedIn && !topCard;
  const hasError = isLoggedIn && (!MRPoints || hasMembershipError);

  return (
    <div
      id="profile-title-section"
      className={clsx(dlsStyles['pad-1-lr'], dlsStyles['pad-t'], dlsStyles['margin-0'], dlsStyles['text-wrap'], dlsStyles['text-align-center'], profileStyles.bodyColor)}
    >
      <div className={clsx(dlsStyles.flex, dlsStyles['flex-column'], dlsStyles['flex-align-center'], dlsStyles['width-full'])}>
        <h3 className={clsx(dlsStyles['heading-sans-xsmall-bold'], profileStyles.heading)} id="cmNameProfile">
          {isLoggedIn
            ? <>{formatMessage({ id: 'welcome.back' })}{firstName && (<span className={dlsStyles['hidden-lg-up']}>, {firstName}</span>)}</>
            : formatMessage({ id: 'access.trips.benefits' })}
        </h3>
        <p className={clsx(dlsStyles['body-xsmall-bold'])}>
          {isLoggedIn ? MRPoints && formatMessage({ id: 'membership.reward.points' }, { points: MRPoints })
            : formatMessage({ id: 'manage.profile.settings' })}
        </p>
      </div>
      {!hasMembershipError && (
      <div className={clsx(profileStyles.cardDetails, dlsStyles['radius-container-sm'])}>
        <div className={clsx(dlsStyles['pad-2'], dlsStyles.flex, dlsStyles['flex-column'], dlsStyles['flex-align-center'])}>
          {isLoggedIn ? topCard
              && (
              <img
                src={topCard.demographics.product.cardArtCdnLink}
                alt={topCardName}
                className={styles.cardArt}
              />
              )
            : <IconAccount size="md" />}
          <p className={clsx(dlsStyles['body-xsmall'], dlsStyles['pad-1-tb'])}>
            {isLoggedIn ? topCardName
              : (
                <>
                  { navLinks?.features.loginLogout === 'true' ? (
                    <a href={navLinks?.generalLinks.login} id="desktopLogin" className={clsx(dlsStyles['pad-0'], dlsStyles['text-underline'])}>
                      {formatMessage({ id: 'login' })}
                    </a>
                  ) : formatMessage({ id: 'login' })}
                  {formatMessage({ id: 'login.prompt' })}
                </>
              )}
          </p>
          {isLoggedIn
              && topCard && (
              <p className={clsx(dlsStyles['color-text-regular'], dlsStyles['body-xsmall'])}>
                ({topCard?.demographics.displayAccountNumber.slice(-6)})
              </p>
          )}
        </div>

        { navLinks?.features.benefits === 'true'
        && <Benefits />}
      </div>
      )}
      {hasError && (
      <p role="alert" className={clsx(dlsStyles['color-text-regular'], dlsStyles['body-xsmall'], profileStyles.cardDetailsError)}>
        {hasMembershipError ? formatMessage({ id: 'membership.error' }) : !MRPoints && formatMessage({ id: 'loyalty.points.error' })}
      </p>
      )}
    </div>
  );
};

export default ProfileDrawerTitleSection;
